import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export function PostsMap({ posts = [], onSelect }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !elRef.current) return;
    const first = posts.find((p) => p.lat != null && p.lng != null);
    const center = first ? [first.lat, first.lng] : [40.7128, -74.006];
    const map = L.map(elRef.current, { scrollWheelZoom: false }).setView(center, 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors", maxZoom: 19,
    }).addTo(map);
    layerRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapRef.current, layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = posts.filter((p) => p.lat != null && p.lng != null);
    const bounds = [];
    pts.forEach((p) => {
      const offer = p.kind === "offer";
      const color = offer ? "#1C3B2B" : "#D94527";
      const icon = L.divIcon({
        className: "",
        html: `<div style="width:34px;height:34px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${color};border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center"><span style="transform:rotate(45deg);color:#fff;font-weight:700;font-size:16px;line-height:1">${offer ? "♥" : "?"}</span></div>`,
        iconSize: [34, 34], iconAnchor: [17, 34], popupAnchor: [0, -32],
      });
      const m = L.marker([p.lat, p.lng], { icon }).addTo(layer);
      m.bindPopup(`<b style="font-size:14px">${p.title}</b><br><span style="color:${color};font-weight:600">${offer ? "Offering help" : "Needs help"}</span>`);
      m.on("click", () => onSelect?.(p));
      bounds.push([p.lat, p.lng]);
    });
    if (bounds.length > 1) map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14 });
    else if (bounds.length === 1) map.setView(bounds[0], 13);
  }, [posts, onSelect]);

  const hasLoc = posts.some((p) => p.lat != null && p.lng != null);
  return (
    <div className="relative">
      <div ref={elRef} data-testid="posts-map" className="relative w-full h-[70vh] rounded-2xl border-2 border-border overflow-hidden z-0" />
      {!hasLoc && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/85 rounded-2xl pointer-events-none">
          <p className="text-forest-700 text-lg font-semibold text-center px-6 max-w-sm">No posts have a location yet. Add your location in your profile so posts show on the map.</p>
        </div>
      )}
    </div>
  );
}
